import React from "react";
import { Loading } from "../../../components/loading";
import { EmptyList } from "../../../components/empty-list";
import { Table, TableHeader, TableBody, TableRow, TableCell } from "../../../components/tables";
import { useSignatureLinks } from "../hooks";
import { formatDisplayDate } from "../../../helpers/date";

interface IProps {
  orderId: number;
}

export const SignatureLinksList: React.FC<IProps> = ({ orderId }) => {
  const { data, loading } = useSignatureLinks({ where: { orderId } });

  if (loading) return <Loading />;

  if (!data?.signatureLinks?.results?.length) {
    return <EmptyList text="Aucun lien de signature" />;
  }

  return (
    <Table>
      <TableHeader>
        <TableRow hover={false}>
          <TableCell header>Token</TableCell>
          <TableCell header>Expire le</TableCell>
          <TableCell header>Consommé le</TableCell>
        </TableRow>
      </TableHeader>
      <TableBody>
        {data?.signatureLinks?.results?.map((link) => (
          <TableRow key={`signature-link-${link.id}`} hover={false}>
            <TableCell>{link.token.slice(0, 12)}...</TableCell>
            <TableCell>{formatDisplayDate(link.expiresAt)}</TableCell>
            <TableCell>{formatDisplayDate(link.consumedAt)}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
